// @flow
import React from 'react';
import Collapsable from 'rc-collapse';

import ExpandIcon from '../ExpandIcon';

import styles from './collapsable.css';


export default (props: mixed) => (
  <Collapsable
    expandIcon={ExpandIcon}
    className={styles.collapsable}
    {...props}
  />
);



// WEBPACK FOOTER //
// ./src/scripts/components/Accordion/Collapsable/index.jsx